/**
 * Thin fetch wrapper for the ALFÀ backend.
 * All backend routes are prefixed with /api (Kubernetes ingress rule).
 */
export const BASE = process.env.REACT_APP_BACKEND_URL;

async function jsonGet(path, opts = {}) {
  const headers = { ...(opts.headers || {}) };
  const res = await fetch(`${BASE}${path}`, { headers });
  if (!res.ok) {
    throw new Error(`GET ${path} → ${res.status}`);
  }
  return res.json();
}

function _adminAuth() {
  const t = localStorage.getItem('alfa_admin_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function jsonPost(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return { ok: res.ok, status: res.status, data: await res.json().catch(() => null) };
}

// ---- Content ----
export const listCategories = () => jsonGet('/api/categories');
export const listProducts = (categoryKey) =>
  jsonGet(`/api/products${categoryKey ? `?category=${encodeURIComponent(categoryKey)}` : ''}`);
export const getProduct = (slug) => jsonGet(`/api/products/${encodeURIComponent(slug)}`);
export const getCategoryContent = (categoryKey) =>
  jsonGet(`/api/category-content/${encodeURIComponent(categoryKey)}`);
export const getMarquee = (key) => jsonGet(`/api/marquee/${encodeURIComponent(key)}`);

// ---- Quiz ----
export const submitQuiz = (payload) => jsonPost('/api/quiz/submit', payload);
export const listQuizSubmissions = (limit = 200) =>
  jsonGet(`/api/quiz/submissions?limit=${limit}`, { headers: _adminAuth() });
export const quizSubmissionsCsvUrl = () => `${BASE}/api/quiz/submissions.csv`;
export const downloadQuizSubmissionsCsv = async () => {
  const res = await fetch(`${BASE}/api/quiz/submissions.csv`, { headers: _adminAuth() });
  if (!res.ok) throw new Error(`CSV → ${res.status}`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = 'alfa-quiz-submissions.csv'; a.click();
  URL.revokeObjectURL(url);
};

// ---- URL slug helpers ----
// URL slug (e.g. "weight-loss") ↔ backend/data key (e.g. "weightLoss")
export const SLUG_TO_KEY = {
  'weight-loss': 'weightLoss',
};
export const KEY_TO_SLUG = Object.fromEntries(
  Object.entries(SLUG_TO_KEY).map(([s, k]) => [k, s]),
);
